module.exports = __webpack_public_path__ + "static/Shield-right-0298bb237fe5bb401927d7464f80e6ec.png";